import TFGTerms from './TFGTerms';

export default TFGTerms;